import { Range, Transforms, Text } from 'slate';
import { isRangeWithinVoid } from '../../queries/isRangeWithinVoid.mjs';

const withVoidMarks = editor => {
  const {
    addMark,
    removeMark
  } = editor;
  editor.addMark = (key, value) => {
    const {
      selection
    } = editor;
    if (selection) {
      if (Range.isExpanded(selection) || isRangeWithinVoid(editor, selection)) {
        Transforms.setNodes(editor, {
          [key]: value
        }, {
          match: Text.isText,
          voids: true,
          split: true
        });
      } else {
        addMark(key, value);
      }
    }
  };
  editor.removeMark = key => {
    const {
      selection
    } = editor;
    if (selection) {
      if (Range.isExpanded(selection) || isRangeWithinVoid(editor, selection)) {
        Transforms.unsetNodes(editor, key, {
          match: Text.isText,
          split: true,
          voids: true
        });
      } else {
        removeMark(key);
      }
    }
  };
  return editor;
};

export { withVoidMarks };
